import React from 'react';
import { Outlet } from 'react-router-dom';

interface BusinessContactsRootPageInterface {}

const BusinessContactsRootPage: React.FC<BusinessContactsRootPageInterface> = () => <Outlet />;

export default BusinessContactsRootPage;
